import { ConnectorStandard } from '@energy-stacks/data';

const alertErrorCodes = [
  'connectorLockFailure',
  'eVCommunicationError',
  'groundFailure',
  'highTemperature',
  'internalError',
  'localListConflict',
  'noError',
  'otherError',
  'overCurrentFailure',
  'overVoltage',
  'powerMeterFailure',
  'powerSwitchFailure',
  'readerFailure',
  'resetFailure',
  'underVoltage',
  'weakSignal',
] as const;
export type AlertErrorCode = (typeof alertErrorCodes)[number];

export const severtities = ['LOW', 'MINOR', 'MAJOR', 'CRITICAL'] as const;
export type Severity = (typeof severtities)[number];

export const alertReasons = [
  'OFFLINE',
  'FAULTED',
  'HIGH_CABLE_TEMPERATURE',
  'CABLE_THEFT',
  'LOWER_SESSION_COUNT',
  'LOW_SESSION_ENERGY',
] as const;
export type AlertReason = (typeof alertReasons)[number];

export interface Alert {
  id: number;
  alertReason: string;
  dateCreated: string;
  dateResolved: string;
  identityKey: string;
  connectorId: number;
  vendorErrorCode: string;
  errorCode: AlertErrorCode | null;
  errorInfo: string;
  evseId: string;
  connectorStandard: ConnectorStandard;
  severity: Severity;
}
export interface AlertManagementModel {
  alerts?: Alert[];
  totalElements: number;
  totalPages: number;
}
